import 'src/layers.css.ts.vanilla.css?source=QGxheWVyIHRibC0tcmVzZXQ7CkBsYXllciB0YmwtLWNvbXBvbmVudHM7';
export var layers = {components:'tbl--components',reset:'tbl--reset'};